import shouldShowShippingFee from '@/catalog/utils/should-show-shipping-fee';
import { Vehicle } from '../../types/vehicle';
import ShippingDetails from '../cross-market/shipping-details';
import PickupAvailability from '../pickup-availability';

interface VehicleInfoProps {
  vehicle: Vehicle;
}

export default function VehicleInfo({ vehicle }: VehicleInfoProps) {
  return (
    <div className="px-6 pt-6 md:px-0 lg:pt-0">
      <h2 className="pdp-header text-[32px] leading-[40px] lg:text-[40px] lg:leading-[48px]">
        {vehicle.model_year} {vehicle.make} {vehicle.model}
      </h2>

      <p className="body-tight mt-2 lg:text-[18px]">
        {[
          vehicle.trim,
          !vehicle.is_new_vehicle &&
            vehicle.odometer &&
            `${vehicle.odometer.toLocaleString('en-US', { maximumFractionDigits: 0 })} mi`,
          vehicle.drivetrain,
        ]
          .filter(Boolean)
          .join(' • ')}
      </p>

      <div className="mt-2 flex gap-1">
        <PickupAvailability
          pickupDays={vehicle.pickup_days}
          earliestAvailableDate={vehicle.earliest_available_date}
          variant="body"
          className="body-tight lg:text-[18px]"
        />

        {shouldShowShippingFee(
          vehicle.cross_market_route,
          vehicle.shipping_fee_breakdown
        ) ? (
          <>
            •
            <ShippingDetails
              crossMarketRoute={vehicle.cross_market_route}
              shippingFeeBreakdown={vehicle.shipping_fee_breakdown}
              hideHelpIcon={true}
              contentAlign="center"
              variant="body1-invoice"
              bodyClassName="body-tight lg:text-[18px] cursor-pointer underline decoration-flexcar-neutral1 decoration-dotted decoration-[2px] underline-offset-[5px] hover:text-flexcar-neutral1 hover:decoration-flexcar-blue50"
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
